export default __webpack_public_path__ + "media/images/icons_fc/luggage-7b6fccd4cf79e6c1be92876e6c97a269.png";